import MarketingImage from '@/components/landing/MarketingImage';
import React from 'react';
import { Link } from 'react-router-dom';
import SignupLink from '@/components/SignupLink';
import { Button } from '@/components/ui/button';
import { Instagram, Linkedin, Mail, MapPin, Twitter } from 'lucide-react';
import styles from './Footer.module.css';
const landingLogo = '/images/marketing/landing-logo-2.webp';
const gdprBadges = '/images/marketing/landing-gdpr-badges-gdpr-badges-flat.svg';
import { openCookiePreferences } from '@/lib/cookieConsent';

const Footer = () => {
  return (
    <footer data-page-footer className={styles.footer}>
      <div className={`landing-container ${styles.footerContent}`}>
        <div className={styles.topRow}>
          <Link to="/" className={styles.brand}>
            <MarketingImage
              loading="lazy"
              src={landingLogo}
              alt="CalorieScience"
              className={styles.brandLogo}
            />
          </Link>

          <Button
            asChild
            className={styles.startButton}
          >
            <SignupLink>Get Started</SignupLink>
          </Button>
        </div>

        <div className={styles.complianceRow}>
          <MarketingImage
            src={gdprBadges}
            alt="GDPR ready and GDPR compliant badges"
            className={styles.complianceImage}
          />
        </div>

        <div className={styles.columns}>
          <div className={styles.socialColumn}>
            <h4>Follow us</h4>
            <div className={styles.socialLinks}>
              <a
                href="https://x.com/caloriescience?s=11&t=85K-BCwOK95MXIZzTBZEpw"
                target="_blank"
                rel="noreferrer"
                aria-label="Follow CalorieScience on X"
              >
                <Twitter aria-hidden="true" />
              </a>
              <a
                href="https://www.linkedin.com/company/caloriescience/"
                target="_blank"
                rel="noreferrer"
                aria-label="Follow CalorieScience on LinkedIn"
              >
                <Linkedin aria-hidden="true" />
              </a>
              <a
                href="https://www.instagram.com/caloriescience?igsh=ZjEyanJhZncyaDVk"
                target="_blank"
                rel="noreferrer"
                aria-label="Follow CalorieScience on Instagram"
              >
                <Instagram aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className={styles.infoColumns}>
            <div>
              <h4>Quick links</h4>
              <a href="#top">Home</a>
              <a href="#for-who">Vision and Mission</a>
              <a href="#for-who">Who is it for</a>
              <Link to="/companion-app">Companion App</Link>
              <Link to="/personalised-nutrition-platform">Personalised Nutrition Platform</Link>
              <Link to="/platform/biomarker-informed-nutrition">Biomarker-Informed Nutrition</Link>
              {/* <a href="#pricing">Pricing</a> */}
            </div>

            <div>
              <h4>Resources</h4>
              <Link to="/#blogs">Insights</Link>
              <Link to="/privacy">
                Privacy Policy
              </Link>
              <Link to="/terms">
                Terms and Conditions
              </Link>
              <Link to="/platform-privacy">
                Platform Privacy
              </Link>
              <Link to="/platform-terms">
                Platform Terms
              </Link>
              <Link to="/refund-cancellation-policy">
                Refund &amp; Cancellation Policy
              </Link>
              <Link to="/cookies">
                Cookie Policy
              </Link>
              <button onClick={openCookiePreferences} className={styles.inlineButton}>
                Cookie Preferences
              </button>
            </div>

            <div>
              <h4>Contact Us</h4>
              <p className={styles.contactItem}>
                <MapPin />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Singapore%20068914"
                  target="_blank"
                  rel="noreferrer"
                  className={styles.addressText}
                >
                  Singapore 068914
                </a>
              </p>
              <p className={styles.contactItem}>
                <Mail />
                <a href="mailto:info@caloriescience.ai">info@caloriescience.ai</a>
              </p>
            </div>
          </div>
        </div>

        <div className={styles.bottomRow}>
          <p>&copy; {new Date().getFullYear()} CalorieScience. All rights reserved.</p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
